export default __webpack_public_path__ + "static/7-6d0afdbe6ba0c53eaa51f58d188e4cce.png";